import './_collection-hatbox-pane.scss';

export default () => {};
